import React from 'react';

import { Skeleton } from '@ergeon/core-components';

const LINE_WIDTHS = ['w-full', 'w-11/12', 'w-full', 'w-4/5', 'w-full', 'w-2/3'];

const NodeSkeleton = () => (
  <div aria-busy="true" aria-label="Loading the article" className="flex flex-col gap-4" role="status">
    <Skeleton className="h-6 w-24 rounded-full" />
    <Skeleton className="h-10 w-3/4" />
    <Skeleton className="h-5 w-1/2" />
    <div className="flex flex-col gap-3 pt-4">
      {LINE_WIDTHS.map((width, index) => <Skeleton className={`h-4 ${width}`} key={index} />)}
    </div>
  </div>
);

export default NodeSkeleton;
